import { useTranslation } from "react-i18next";
import PageTitle from "../components/common/PageTitle";
import { PageWrapper } from "../components/common/PageWrapper";
import { useMutation, useQuery } from "react-query";
import { getAllPromo, upsertPromo } from "../shared/queries";
import BaseTable from "../components/data/BaseTable";
import { Promotion } from "../types";
import dayjs from "dayjs";
import Button from "../components/form/Button";
import { useState } from "react";
import EntityUpdateDialog from "../components/common/EntityUpdateDialog";
import toast from "react-hot-toast";

export default function Promotions () {

  const { t } = useTranslation()

  const { data, refetch, isLoading } = useQuery('promotions', getAllPromo)
  const [currentPromotion, setCurrentPromotion] = useState<Promotion>()

  const upsertMutation = useMutation((promotion: Promotion) => upsertPromo(promotion), {
    onSuccess: async () => {
      refetch()
      setUpdatePromotion(false)
      setCurrentPromotion(undefined)
    },
    onError: (data: any) => {
      toast.error(`Impossibile completare, contatta IT Team: ${data.message}`)
    }
  })
  
  const [updatePromotion, setUpdatePromotion] = useState(false)

  return (
    <PageWrapper centered maxWidth={'1000px'}>

      <EntityUpdateDialog
        fields={[
            {
              label: 'Promocode',
              value: '',
              field: 'promoCode'
            },
            {
              label: 'Descrizione',
              value: '',
              field: 'description'
            },
            {
              label: 'Data inizio promozione',
              type: 'date',
              value: '',
              field: 'enrollmentStartDate'
            },
            {
              label: 'Data fine promozione',
              type: 'date',
              value: '',
              field: 'enrollmentEndDate'
            },
            {
              label: 'Numero fatture applicabili',
              value: '',
              field: 'cashbackInvoices'
            },
            {
              label: 'Soglia minima',
              value: '',
              field: 'activationThreshold'
            },
            {
              label: '% di cashback',
              value: '',
              field: 'cashbackPercentage'
            },
            {
              label: 'Data scadenza promozione',
              type: 'date',
              value: '',
              field: 'expirationDate'
            },
            {
              label: 'Attiva',
              type: 'checkbox',
              value: '',
              field: 'active'
            },
            {
              label: 'Privata',
              type: 'checkbox',
              value: '',
              field: 'isPrivate'
            },
            {
              label: 'Includi mese corrente',
              type: 'checkbox',
              value: '',
              field: 'includeCurrentMonth'
            }
        ]}
        visible={updatePromotion}
        onClose={() => setUpdatePromotion(false)}
        onSave={(data: any) => upsertMutation.mutate(data)}
        title={`Promozione`}
        data={currentPromotion}
      />

      <PageTitle
        title={'Gestione promozioni'}
        renderActions={() => {
          return (
            <Button
              className="bg-orange-600 text-white"
              label="Nuova"
              onClick={() => {
                setCurrentPromotion({
                  idPromo: undefined,
                  promoCode: '',
                  description: '',
                  enrollmentStartDate: dayjs().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
                  enrollmentEndDate: dayjs().add(2, 'day').format('YYYY-MM-DDTHH:mm:ss'),
                  cashbackInvoices: 1,
                  activationThreshold: 1,
                  cashbackPercentage: 10,
                  expirationDate: dayjs().add(2, 'months').format('YYYY-MM-DDTHH:mm:ss'),
                  promoType: 'CASHBACK',
                  active: false,
                  isPrivate: false,
                  includeCurrentMonth: false
                })
                setUpdatePromotion(true)
              }}
            />
          )
        }}
      />

      <BaseTable
        loading={isLoading}
        showFilters={false}
        showColumnSelector={false}
        data={data}
        filterable={false}
        paginated={false}
        identifierKey={'idPromo'}
        columns={[
            {
                Header: 'Promocode',
                accessor: (row: Promotion) => {
                    return <a onClick={e => {
                      e.preventDefault()
                      setCurrentPromotion(row)
                      setUpdatePromotion(true)
                    }} className="text-orange-600 underline" href={''}>{row.promoCode}</a>
                }
            },
            {
                Header: 'Enrollment period',
                accessor: (row: Promotion) => {
                    return (
                      <div className="flex space-x-2 items-center">
                        <div>
                          {dayjs(row.enrollmentStartDate).format('DD/MM/YY')}
                        </div>
                        <div className="text-slate-400">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                          </svg>
                        </div>
                        <div>
                          {dayjs(row.enrollmentEndDate).format('DD/MM/YY')}
                        </div>
                      </div>
                    )
                }
            },
            {
                Header: 'Cashback months',
                accessor: (row: Promotion) => {
                    return row.cashbackInvoices
                }
            },
            {
              Header: 'Cashback %',
              accessor: (row: Promotion) => {
                  return row.cashbackPercentage + '%'
              }
            },
            {
              Header: 'Current month',
              accessor: (row: Promotion) => {
                  return (row.includeCurrentMonth) ? '✅' : '⛔'
              }
            },
            {
              Header: 'Private',
              accessor: (row: Promotion) => {
                  return (row.isPrivate) ? '✅' : '⛔'
              }
            }
        ]}
      />
    </PageWrapper>
  )

}